import styled from "styled-components";

import { colors } from "components";

interface IStyles {
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
  size?: string;
}

interface IButtonContainer extends IStyles {
  backgroundColor?: string;
  borderColor?: string;
  backgroundHoverColor?: string;
  borderHoverColor?: string;
  textColor?: string;
  textColorHover?: string;
}

export const Container = styled.button<IButtonContainer>`
  margin-left: ${({ marginLeft }) =>
    marginLeft && marginLeft.includes("px") ? marginLeft : `${marginLeft}px`};
  margin-right: ${({ marginRight }) =>
    marginRight && marginRight.includes("px")
      ? marginRight
      : `${marginRight}px`};
  margin-top: ${({ marginTop }) =>
    marginTop && marginTop.includes("px") ? marginTop : `${marginTop}px`};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom && marginBottom.includes("px")
      ? marginBottom
      : `${marginBottom}px`};

  border: none;
  background: none;
  padding: 0;
  width: 100%;

  .button {
    border-radius: 50px;
    box-shadow: none;
    background: ${(props) => props.backgroundColor ?? colors.primary_default};

    border: ${(props) =>
      props.borderColor
        ? `2px solid ${props.borderColor}`
        : `2px solid ${colors.primary_default}`};
  }

  .button:hover {
    border-radius: 50px;
    box-shadow: none;
    background: ${(props) => props.backgroundHoverColor ?? colors.primary_dark};

    border: ${(props) =>
      props.borderHoverColor
        ? `2px solid ${props.borderHoverColor}`
        : `2px solid ${colors.primary_dark}`};

    #textButtonId div {
      color: ${(props) => props.textColorHover ?? props.textColor};
    }
  }
`;
